import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({commit}, params) {
      const {data} = await axios.get('/v1/services/chat/chat-group', {params})

      if (!data.success) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
